const PeoplePickerActions = {
  ADD: 'add',
  DELETE: 'delete',
  properties: {
    add: {
      key: 'add',
      value: 'add'
    },
    delete: {
      key: 'delete',
      value: 'delete'
    }
  }
}

export { PeoplePickerActions }